export const selectToken = (state: any) => state.auth.token;
export const selectUser = (state: any) => state.auth.user;
export const selectTabIndex = (state: any) => state.clientProfile.tabIndex;
export const selectCheckedIn = (state: any) => state.auth.checkedIn;
